<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";
  
  </script>
<Card>
<CardBody>

<img
    src="assets/images/KLAID_identity_motion_small.gif"
    alt=""
    class="img-thumbnail mx-auto d-block"
/>

</CardBody>
</Card>